<h1 class="page-header"><i class="fa fa-history" aria-hidden="true"></i> HISTORY</h1>
<div class="container-fluid">

  <div class="row">
    <div class="col-sm-5">
        <div class="page-button">
            <button type="button" class="btn btn-danger" [disabled]="!historyPaused" (click)="stopHistory()"><i class="fa fa-stop" aria-hidden="true"></i> STOP</button>
            <button type="button" class="btn btn-default edgefinityHeader" (click)="resetHistory()" [disabled]="!historyPaused" [class.disabled]="!historyPaused"><i class="fa fa-retweet" aria-hidden="true"></i> RESET</button>
            <button type="button" class="btn btn-primary edgefinityHeader" [disabled]="disableControls" [class.disabled]="disableRunHistory" (click)="runHistory()"><i class="fa fa-arrow-right" aria-hidden="true"></i> RUN HISTORY</button>
        </div>
      <div class="panel panel-default">
        <div class="panel-heading"><i class="fa fa-calendar" aria-hidden="true"></i> DATE & TIME</div>
          <div class="panel-body">
            <div class="row tab-button">
              <!-- <div class="col-sm-6"> -->
                <div class="form-group">
                  <!-- <label>FROM</label> -->
                  <div class="input-group date">

                      <input [owlDateTime]="dtPicker1" [selectMode]="'range'"
                             [(ngModel)]="selectedMoments" #dateTime="ngModel"  class="form-control" />
                      <span [owlDateTimeTrigger]="dtPicker1" class="input-group-addon">
                          <i class="fa fa-calendar" aria-hidden="true"></i>
                      </span>
                    <owl-date-time #dtPicker1 (afterPickerClosed)="datesSelected()" [hour12Timer]="true"></owl-date-time>
                  </div>

                </div>
              <!--</div> -->

              <!-- <div class="col-sm-6">
                <div class="form-group">
                  <label>TO</label>
                  <div class="input-group date">
                    <input [owlDateTime]="dt2" class="form-control" id="dateTo" />
                    <span [owlDateTimeTrigger]="dt2" class="input-group-addon">
                          <i class="fa fa-calendar" aria-hidden="true"></i>
                      </span>

                  </div>
                  <owl-date-time #dt2 (afterPickerClosed)="dateToSelected()" [hour12Timer]="true"></owl-date-time>
                </div>
              </div>
              -->
            </div>
          </div>
        </div>


        <ul class="nav nav-tabs">
          <li class="active" ><a data-toggle="tab" href="#home"><i class="fa fa-map" aria-hidden="true"></i> LOCATIONS</a></li>
          <li><a data-toggle="tab" href="#people"><i class="fa fa-users" aria-hidden="true"></i> PEOPLE</a></li>
          <li><a data-toggle="tab" href="#assets"><i class="fa fa-cube" aria-hidden="true"></i> ASSETS</a></li>
          <li><a data-toggle="tab" href="#vehicles"><i class="fa fa-truck" aria-hidden="true"></i> VEHICLES</a></li>
        </ul>

        <div class="tab-content">
          <div id="home" class="tab-pane fade in active">

            <div class = "input-group">
              <input type="text" class="form-control" placeholder="Search For Locations..." [(ngModel)]="locationSearch" (ngModelChange)="locationSearchValueChanged()" [disabled]="disableControls" [class.disabled]="disableControls">
              <span class="input-group-btn">
                <div class="dropdown">
                  <button class="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown" [disabled]="disableControls" [class.disabled]="disableControls">SEARCH BY
                  <span class="caret"></span></button>
                  <ul class="dropdown-menu">
                    <li><a href="#">NAME</a></li>
                    <li><a href="#">GROUP</a></li>
                  </ul>
                </div>
              </span>
            </div>

            <div>
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th class="table-checkbox"><div class="checkbox checkbox-inline"><input type="checkbox" [(ngModel)]="allLocationsSelected" (ngModelChange)="selectOrDeselectAllLocations()" class="styled" [disabled]="disableControls" [class.disabled]="disableControls"><label></label></div></th>
                    <th>LOCATION</th>
                  </tr>
                </thead>
                <tbody>
                  <ng-container *ngFor="let location of locations">
                    <ng-container *ngIf="location.viewable">
                      <tr>
                        <td><div class="checkbox checkbox-inline"><input type="checkbox" class="styled" [(ngModel)]="location.selected"  [disabled]="disableControls" [class.disabled]="disableControls" (ngModelChange)="checkRunParameters()"><label></label></div></td>
                        <td>{{ location.locationInstance.name }}</td>
                      </tr>
                    </ng-container>
                  </ng-container>
                </tbody>
              </table>
            </div>
          </div>

          <div id="menu1" class="tab-pane fade">
            <div class = "input-group">
              <input type = "text" class = "form-control" placeholder="Search For Something..." [(ngModel)]="assetSearch" (ngModelChange)="assetSearchValueChanged()"  [disabled]="disableControls" [class.disabled]="disableControls">
              <span class="input-group-btn">
                <div class="dropdown">
                  <button class="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown" [disabled]="disableControls" [class.disabled]="disableControls">SEARCH BY
                  <span class="caret"></span></button>
                  <ul class="dropdown-menu">
                    <li><a href="#">NAME</a></li>
                    <li><a href="#">GROUP</a></li>
                  </ul>
                </div>
              </span>
            </div>
          </div>

          <div id="menu2" class="tab-pane fade">
            <div class = "input-group">
              <input type = "text" class = "form-control" placeholder="Search For a Vehicle..." [(ngModel)]="vehicleSearch"  [disabled]="disableControls" [class.disabled]="disableControls">
              <span class="input-group-btn">
                <div class="dropdown">
                  <button class="btn btn-default dropdown-toggle" type="button" data-toggle="dropdown" [disabled]="disableControls" [class.disabled]="disableControls">SEARCH BY
                  <span class="caret"></span></button>
                  <ul class="dropdown-menu">
                    <li><a href="#">NAME</a></li>
                    <li><a href="#">GROUP</a></li>
                  </ul>
                </div>
              </span>
            </div>
          </div>

          <div id="people" class="tab-pane fade">
            <div class = "input-group">
              <input type = "text" class = "form-control" placeholder="Search For People..." [(ngModel)]="peopleSearch" (ngModelChange)="peopleSearchValueChanged()" [disabled]="disableControls" [class.disabled]="disableControls">
              <span class="input-group-btn">
                <div class="dropdown">
                  <button class="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown" [disabled]="disableControls" [class.disabled]="disableControls">SEARCH BY
                  <span class="caret"></span></button>
                  <ul class="dropdown-menu">
                    <li><a href="#">NAME</a></li>
                    <li><a href="#">GROUP</a></li>
                  </ul>
                </div>
              </span>
            </div>

            <div>
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th class="table-checkbox"><div class="checkbox checkbox-inline"><input type="checkbox" [(ngModel)]="allPeopleSelected" (ngModelChange)="selectOrDeselectAllPeople()" class="styled"  [disabled]="disableControls" [class.disabled]="disableControls"><label></label></div></th>
                    <th>NAME</th>
                    <th>GROUP(S)</th>
                  </tr>
                </thead>
                <tbody>
                <ng-container *ngFor="let person of people">
                  <ng-container *ngIf="person.viewable">
                    <tr>
                      <td><div class="checkbox checkbox-inline"><input type="checkbox"  class="styled" [(ngModel)]="person.selected" [disabled]="disableControls" [class.disabled]="disableControls" (ngModelChange)="checkRunParameters()"><label></label></div></td>
                      <td><img [src]="getIconSourceForObjectInstance(person.person)" /> {{ person.person.name }}</td>
                      <td>
                        <ng-container *ngIf="person.person.groups != null && person.person.groups.length > 0">
                          <ng-container *ngFor="let group of person.person.groups">
                            <button class="groupButton" (click)="selectPersonGroup(group, person.selected)">{{group.name}}</button>&nbsp;
                          </ng-container>
                        </ng-container>
                      </td>
                    </tr>
                  </ng-container>
                </ng-container>
                </tbody>
              </table>
            </div>
          </div>

       <div id="assets" class="tab-pane fade">
          <div class = "input-group">
            <input type = "text" class = "form-control" placeholder="Search For Something..." [(ngModel)]="assetSearch" (ngModelChange)="assetSearchValueChanged()" [disabled]="disableControls" [class.disabled]="disableControls">
            <span class="input-group-btn">
              <div class="dropdown">
                <button class="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown" [disabled]="disableControls" [class.disabled]="disableControls">SEARCH BY
                <span class="caret"></span></button>
                <ul class="dropdown-menu">
                  <li><a href="#">NAME</a></li>
                  <li><a href="#">GROUP</a></li>
                </ul>
              </div>
            </span>
          </div>
          <div>
             <table class="table table-hover">
                <thead>
                <tr>
                <th class="table-checkbox"><div class="checkbox checkbox-inline"><input type="checkbox" [(ngModel)]="allAssetsSelected" (ngModelChange)="selectOrDeselectAllAssets()" class="styled" [disabled]="disableControls" [class.disabled]="disableControls"><label></label></div></th>
                  <th>NAME</th>
                  <th>GROUP(S)</th>
                </tr>
              </thead>
              <tbody>
              <ng-container *ngFor="let asset of assets">
                <ng-container *ngIf="asset.viewable">
                  <tr>
                    <td><div class="checkbox checkbox-inline"><input type="checkbox" [(ngModel)]="asset.selected" class="styled" [disabled]="disableControls" [class.disabled]="disableControls" (ngModelChange)="checkRunParameters()"><label></label></div></td>
                    <td><img [src]="getIconSourceForObjectInstance(asset.objectInstance)" /> {{ asset.objectInstance.name }}</td>
                    <td>
                      <ng-container *ngIf="asset.objectInstance.groups != null && asset.objectInstance.groups.length > 0">
                        <ng-container *ngFor="let group of asset.objectInstance.groups">
                          <button class="groupButton" (click)="selectAssetGroup(group, asset.selected)">{{group.name}}</button>&nbsp;
                        </ng-container>
                      </ng-container>
                    </td>
                  </tr>
                </ng-container>
              </ng-container>
              </tbody>
            </table>
          </div>
       </div>

       <div id="vehicles" class="tab-pane fade">
          <div class = "input-group">
              <input type = "text" class = "form-control" placeholder="Search For Vehicles..." [disabled]="disableControls" [class.disabled]="disableControls">
              <span class="input-group-btn">
              <div class="dropdown">
                <button class="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown" [disabled]="disableControls" [class.disabled]="disableControls">SEARCH BY
                <span class="caret"></span></button>
                <ul class="dropdown-menu">
                  <li><a href="#">NAME</a></li>
                  <li><a href="#">GROUP</a></li>
                </ul>
              </div>
              </span>
              </div>
                  <div>
                 <table class="table table-hover">
                    <thead>
                    <tr>
                    <th class="table-checkbox"><div class="checkbox checkbox-inline"><input type="checkbox" class="styled" [disabled]="disableControls" [class.disabled]="disableControls"></div></th>
                      <th>NAME</th>
                      <th>GROUP(S)</th>
                    </tr>
                  </thead>
                  <tbody>
                  </tbody>
                </table>
                  </div>
           </div>
        </div>
      </div>

      <div class="col-sm-7">
        <div class="panel panel-default">
          <div class="panel-heading">
            <div class="pull-right" style="padding-right: 150px">
            <h5>{{ historyCurrentTime }}</h5>
          </div>
            <!-- If no location is selected yet - display LOCATION in the top left of the map -->
            <ng-container *ngIf="selectedLocationInstances.length == 0">
              <button class="btn btn-sm btn-default"><i class="fa fa-map" aria-hidden="true"></i>&nbsp;LOCATION</button>
            </ng-container>

            <!-- If only one location is selected, display the location name in the top left of the map -->
            <ng-container *ngIf="selectedLocationInstances.length == 1">
              <button class="btn btn-sm btn-default"><i class="fa fa-map" aria-hidden="true"></i>&nbsp;{{currentLocationInstance.name.toUpperCase()}}</button>
            </ng-container>

            <!-- If more than one location is selected, user can click on dropdown menu to change the currently displayed location -->
            <div ngbDropdown *ngIf="selectedLocationInstances.length > 1">
              <button class="btn btn-sm btn-default" id="location-dropdown" ngbDropdownToggle><i class="fa fa-map" aria-hidden="true"></i>&nbsp;{{currentLocationInstance.name.toUpperCase()}}&nbsp;<span class="caret"></span></button>
              <div ngbDropdownMenu aria-labelledby="location-dropdown">
                <li *ngFor="let locInst of selectedLocationInstances; let i = index">
                  <a class="dropdown-item" (click)="changeCurrentMap(i)">{{locInst.name}}</a>
                </li>
              </div>
            </div>

          </div>

          <div class="panel-body">
            <app-map #historyMap [location]="currentLocationInstance" [displayZones]="displayZones" [showBreadcrumbs]="showBreadcrumbs" [displayPerimeters]="displayPerimeters"></app-map>
          </div>

          <div class="panel-footer">
            <div class="row">

            <div class="col-sm-1">
                <ng-container *ngIf="historyData && historyData.length > 0">
                    <ng-container *ngIf="historyPaused">
                      <i class="fa fa-play-circle fa-3x" aria-hidden="true" (click)="playHistory()"></i>
                    </ng-container>
                    <ng-container *ngIf="!historyPaused">
                      <i class="fa fa-pause-circle fa-3x" aria-hidden="true" (click)="pauseHistory()"></i>
                    </ng-container>
                  </ng-container>
            </div>

           <div class="col-sm-10">
            <input style="margin-top: 8px" type="range" class="slider" min="{{ historyRangeMin }}" max="{{ historyRangeMax }}" value="{{ historyRangeValue }}" (change)="historyRangeChanged($event)"><!-- [disabled]="historyBarDisabled"> -->
          </div>

          <div class="col-sm-1">
              <div class="dropup">
                <button class="btn btn-sm btn-primary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i class="fa fa-cog" aria-hidden="true"></i>&nbsp;<i class="fa fa-caret-down" aria-hidden="true"></i></button>
                <ul class="dropdown-menu dropdown-menu-right" onclick="event.stopPropagation();">
                  <li class="dropdown-header"><i class="fa fa-map-pin" aria-hidden="true"></i> Map Settings</li>
                  <li><a><div class="checkbox checkbox-inline"><input type="checkbox" [(ngModel)]="displayPerimeters" class="styled" id="displayPerimeters"><label for="displayPerimeters">SHOW PERIMETERS</label></div></a></li>
                  <li><a><div class="checkbox checkbox-inline"><input type="checkbox" [(ngModel)]="showBreadcrumbs" class="styled" id="showBreadcrumbs"><label for="showBreadcrumbs">SHOW BREADCRUMBS</label></div></a></li>
                  <li><a><div class="checkbox checkbox-inline"><input type="checkbox" [(ngModel)]="displayZones" class="styled" id="displayZones"><label for="displayZones">SHOW ZONES</label></div></a></li>
                  <li class="divider"></li>
                  <li class="dropdown-header"><i class="fa fa-tachometer" aria-hidden="true"></i> Speed <label for="speed">{{ speed.value }}x</label></li>

                  <li>
                    <div class="col-sm-12">
                      <input type="range" class="speed-slider" #speed (input)="speed.value" (change)="setHistorySpeed(1000 / speed.value)" id="speed" min="1" max="10" value="1">
                    </div>
                  </li>

                </ul>
              </div>
              </div>

              <div class="col-sm-12">
                  <ng-container *ngIf="historySecondsTotalAsTime">
                    <div style="margin: auto">{{ historySecondsElapsedAsTime }} / {{ historySecondsTotalAsTime }}</div>
                  </ng-container>
                </div>

            </div>
          </div>
        </div>
      </div>
  </div>

</div>

<app-history-dialog #historyDialog [statusText]="historyDialogStatusText" [percentageDone]="historyDialogPercentageDone" [okButtonEnabled]="okButtonEnabled" (cancelHistory)="cancelHistoryButtonClicked()"></app-history-dialog>
<app-history-error-dialog #historyErrorDialog [historyError]="historyRequestError"></app-history-error-dialog>
<!-- Simple Success Error Dialog Box - Displaying the Error generated for now since we dont display success msgs -->
<ef-simple-success-error-dialog-box #successErrorDialog></ef-simple-success-error-dialog-box>


